// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"Header_headerWrapper__2pTih","LoginHeaderBlock":"Header_LoginHeaderBlock__252Jg","headerLogo":"Header_headerLogo__2EvWl","closeButton":"Header_closeButton__29LLA"};